import type { FC } from "react"
import { useController, useFormContext } from "react-hook-form"

import type { PaymentTermsFormValues } from "../schemas/paymentTermsFormSchema"

import { AerosSelect } from "@/components/UiKit/AerosSelect"
import { PermissionActionType } from "@/constants/permissions"
import { usePermissionManager } from "@/hooks/usePermissionManager"
import type { Option } from "@/types/form-fields"

const OPTIONS: Option<string>[] = [
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
]

export const SensitiveAccountField: FC = () => {
  const { control } = useFormContext<PaymentTermsFormValues>()
  const { hasPermissions } = usePermissionManager()
  const canEditSensitiveAccount = hasPermissions([PermissionActionType.SENSITIVE_ACCOUNT_MAINTENANCE])

  const {
    field,
    fieldState: { error },
  } = useController({ control, name: "sensitiveAccount" })

  const handleChange = (value: string | null) => {
    field.onChange(value === null ? null : value === "true")
  }

  return (
    <AerosSelect<string>
      label='Sensitive Account'
      placeholder='Select One'
      options={OPTIONS}
      value={typeof field.value === "boolean" ? String(field.value) : null}
      onChange={handleChange}
      disabled={!canEditSensitiveAccount}
      error={!!error}
      helperText={error?.message}
      data-testid='vendor.accounting.sensitive-account-field'
    />
  )
}
